var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconFamily40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_17755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2865 20.1328C14.7391 20.1328 16.7273 18.1446 16.7273 15.692C16.7273 13.2394 14.7391 11.2512 12.2865 11.2512C9.83391 11.2512 7.8457 13.2394 7.8457 15.692C7.8457 18.1446 9.83391 20.1328 12.2865 20.1328Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2862 20.1326C15.9651 20.1326 18.9474 23.4463 18.9474 27.5339V34.9352H6.36513C5.95637 34.9352 5.625 34.6038 5.625 34.1951V27.5339C5.625 23.4463 8.60731 20.1326 12.2862 20.1326Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3484 16.4319C29.2097 16.4319 31.5293 14.1123 31.5293 11.251C31.5293 8.38965 29.2097 6.07007 26.3484 6.07007C23.4871 6.07007 21.1675 8.38965 21.1675 11.251C21.1675 14.1123 23.4871 16.4319 26.3484 16.4319Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3486 16.4319C30.4362 16.4319 33.7499 20.574 33.7499 25.6835V34.195C33.7499 34.6038 33.4185 34.9352 33.0098 34.9352H18.9473V25.6835C18.9473 20.574 22.2609 16.4319 26.3486 16.4319Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_17755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconFamily40);
export default __webpack_public_path__ + "static/media/pictogramBeaconFamily40.bbd61366c0cda4ed03787dd41566ee35.svg";
export { ForwardRef as ReactComponent };